module.exports = "<div class=\"pr-0 card-digest\">\n   <app-date-digest></app-date-digest>\n</div>\n<div class=\"pr-0 card-digest\">\n   <app-funds-digest></app-funds-digest>\n</div>\n<div class=\"pr-1 card-digest\">\n   <app-customers-digest></app-customers-digest>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/company-digest/company-digest.component.html
// module id = ./src/app/web/game/management/company-digest/company-digest.component.html
// module chunks = main